"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _microApiClient = require("micro-api-client");

var _microApiClient2 = _interopRequireDefault(_microApiClient);

var _calculator = require("./calculator");

var _claims = require("./claims");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HTTPRegexp = /^http:\/\//;
var cartKey = "gocommerce.shopping-cart";
var vatnumbers = {};

function getPrice(prices, currency, user) {
  return prices.filter(function (price) {
    return currency == (price.currency || "USD").toUpperCase();
  }).filter(function (price) {
    return price.claims ? (0, _claims.checkClaims)(user && user.claims && user.claims(), price.claims) : true;
  }).map(function (price) {
    price.cents = price.cents || parseInt(parseFloat(price.amount) * 100);
    return price;
  }).sort(function (a, b) {
    return a.cents - b.cents;
  })[0];
}

function priceObject(cents, currency) {
  return { cents: cents, amount: centsToAmount(cents), currency: currency };
}

function addPrices() {
  var result = {
    cents: 0
  };

  for (var _len = arguments.length, prices = Array(_len), _key = 0; _key < _len; _key++) {
    prices[_key] = arguments[_key];
  }

  prices.forEach(function (price) {
    if (price) {
      if (!price.hasOwnProperty("cents")) {
        price.cents = parseInt(parseFloat(price.amount) * 100);
      }
      result.cents += price.cents;
      result.currency = price.currency;
    }
  });
  result.amount = centsToAmount(result.cents);
  return result;
}

function centsToAmount(cents) {
  return "" + (Math.round(cents) / 100).toFixed(2);
}

function pathWithQuery(path, params) {
  if (params) {
    var query = [];
    for (var key in params) {
      query.push(encodeURIComponent(key) + "=" + encodeURIComponent(params[key]));
    }
    return path + "?" + query.join("&");
  }
  return path;
}

var GoCommerce = function () {
  function GoCommerce(options) {
    _classCallCheck(this, GoCommerce);

    if (!options.APIUrl) {
      throw 'You must specify an APIUrl of your GoCommerce instance';
    }
    if (options.APIUrl.match(HTTPRegexp)) {
      console.log('Warning:\n\nDO NOT USE HTTP IN PRODUCTION FOR GOCOMMERCE EVER!\GOCOMMERCE REQUIRES HTTPS to work securely.');
    }
    this.cartKey = options.cartKey || cartKey;

    this.api = new _microApiClient2.default(options.APIUrl);
    this.currency = options.currency || "USD";
    this.billing_country = options.country;
    this.settings_path = "/gocommerce/settings.json";
    this.settings_refresh_period = options.settingsRefreshPeriod || 10 * 60 * 1000;
    this.loadCart();
  }

  _createClass(GoCommerce, [{
    key: "setUser",
    value: function setUser(user) {
      this.user = user;
    }
  }, {
    key: "addToCart",
    value: function addToCart(item) {
      var _this = this;

      var path = item.path,
          quantity = item.quantity,
          meta = item.meta;

      if (quantity && path) {
        return fetch(path).then(function (response) {
          if (!response.ok) {
            return Promise.reject("Failed to fetch " + path);
          }

          return response.text().then(function (html) {
            var doc = document.implementation.createHTMLDocument("product");
            doc.documentElement.innerHTML = html;
            var products = Array.from(doc.getElementsByClassName("gocommerce-product")).map(function (el) {
              return JSON.parse(el.innerHTML);
            });

            if (products.length === 0) {
              return Promise.reject("No .gocommerce-product found in product path");
            }

            var sku = products.length === 1 ? item.sku || products[0].sku : item.sku;

            var product = products.find(function (prod) {
              return prod.sku === sku;
            });
            if (!product) {
              return Promise.reject("No .gocommerce-product matching sku=" + sku + " found in product path");
            }

            var title = product.title,
                prices = product.prices,
                description = product.description,
                type = product.type,
                vat = product.vat;

            if (sku && title && prices) {
              if (_this.line_items[sku]) {
                _this.line_items[sku].quantity += quantity;
                if (meta) {
                  _this.line_items[sku].meta = _extends({}, _this.line_items[sku].meta, meta);
                }
              } else {
                _this.line_items[sku] = _extends(product, { path: path, meta: meta, quantity: quantity });
              }
              if (item.addons && product.addons) {
                _this.line_items[sku].addons = product.addons.filter(function (addon) {
                  return item.addons.indexOf(addon.sku) !== -1;
                });
                _this.line_items[sku].addonPrice = addPrices.apply(undefined, _toConsumableArray(_this.line_items[sku].addons.map(function (addon) {
                  return addon.price;
                })));
              } else {
                delete _this.line_items[sku].addons;
              }
              return _this.loadSettings().then(function () {
                _this.persistCart();
                return _this.getCart();
              });
            } else {
              return Promise.reject("Failed to read sku, title and price from product path: %o", { sku: sku, title: title, prices: prices });
            }
          });
        });
      } else {
        return Promise.reject("Invalid item - must have path and quantity");
      }
    }
  }, {
    key: "getCartItem",
    value: function getCartItem(item_data) {
      var _this2 = this;

      var item = _extends({}, item_data, {
        price: getPrice(item_data.prices, this.currency, this.user)
      });
      (item.price.items || []).forEach(function (priceItem) {
        priceItem.cents = (parseFloat(priceItem.amount) * 100).toFixed(0);
      });
      if (item_data.addons) {
        item.addons = [];
        item_data.addons.forEach(function (addon) {
          item.addons.push(_extends({}, addon, {
            price: getPrice(addon.prices, _this2.currency, _this2.user)
          }));
        });
      }
      if (item.addons) {
        item.addonPrice = priceObject(item.addons.reduce(function (sum, addon) {
          return sum + parseFloat(addon.price.amount) * 100;
        }, 0), this.currency);
      }
      return item;
    }
  }, {
    key: "calculatePrice",
    value: function calculatePrice(item_data, claims) {
      var item = this.getCartItem(item_data);
      claims = claims || this.user && this.user.claims && this.user.claims();
      return (0, _calculator.calculatePrices)(this.settings, claims, this.billing_country, this.currency, this.coupon, [item]);
    }
  }, {
    key: "getCart",
    value: function getCart() {
      var cart = { items: {} };
      var items = [];
      for (var key in this.line_items) {
        var item = cart.items[key] = this.getCartItem(this.line_items[key]);
        items.push(item);
      }

      var claims = this.user && this.user.claims && this.user.claims();
      var price = (0, _calculator.calculatePrices)(this.settings, claims, this.billing_country, this.currency, this.coupon, items);

      cart.subtotal = priceObject(price.subtotal, this.currency);
      cart.discount = priceObject(price.discount, this.currency);
      cart.couponDiscount = priceObject(price.couponDiscount, this.currency);
      cart.memberDiscount = priceObject(price.memberDiscount, this.currency);
      cart.taxes = priceObject(price.taxes, this.currency);
      cart.total = priceObject(price.total, this.currency);

      return cart;
    }
  }, {
    key: "setCurrency",
    value: function setCurrency(currency) {
      this.currency = currency;
      return Promise.resolve(this.getCart());
    }
  }, {
    key: "setCountry",
    value: function setCountry(country) {
      this.billing_country = country;
      return Promise.resolve(this.getCart());
    }
  }, {
    key: "setVatnumber",
    value: function setVatnumber(vatnumber) {
      var _this3 = this;

      this.vatnumber = vatnumber;
      return this.verifyVatnumber(vatnumber).then(function () {
        return _this3.getCart();
      });
    }
  }, {
    key: "setCoupon",
    value: function setCoupon(code) {
      var _this4 = this;

      if (code == null) {
        this.coupon = null;
        return Promise.resolve(null);
      }
      return this.verifyCoupon(code).then(function (coupon) {
        _this4.coupon = coupon;
        return coupon;
      });
    }
  }, {
    key: "updateCart",
    value: function updateCart(sku, quantity) {
      if (this.line_items[sku]) {
        if (quantity > 0) {
          this.line_items[sku].quantity = quantity;
        } else {
          delete this.line_items[sku];
        }
        this.persistCart();
      } else {
        throw "Item " + sku + " not found in cart";
      }
    }
  }, {
    key: "clearCart",
    value: function clearCart() {
      this.line_items = {};
      this.persistCart();
    }
  }, {
    key: "order",
    value: function order(orderDetails) {
      var _this5 = this;

      var email = orderDetails.email,
          shipping_address = orderDetails.shipping_address,
          shipping_address_id = orderDetails.shipping_address_id,
          billing_address = orderDetails.billing_address,
          billing_address_id = orderDetails.billing_address_id,
          data = orderDetails.data;


      if (email && (shipping_address || shipping_address_id)) {
        var _ret = function () {
          var line_items = [];
          for (var id in _this5.line_items) {
            line_items.push(_this5.line_items[id]);
          }

          return {
            v: _this5.authHeaders().then(function (headers) {
              return _this5.api.request("/orders", {
                method: "POST",
                headers: headers,
                body: JSON.stringify({
                  email: email,
                  shipping_address: shipping_address, shipping_address_id: shipping_address_id,
                  billing_address: billing_address, billing_address_id: billing_address_id,
                  vatnumber: _this5.vatnumber_valid ? _this5.vatnumber : null,
                  currency: _this5.currency,
                  coupon: _this5.coupon ? _this5.coupon.code : null,
                  data: data,
                  line_items: line_items
                })
              });
            }).then(function (order) {
              var cart = _this5.getCart();
              return { cart: cart, order: order };
            })
          };
        }();

        if ((typeof _ret === "undefined" ? "undefined" : _typeof(_ret)) === "object") return _ret.v;
      } else {
        return Promise.reject("Invalid orderDetails - must have an email and either a shipping_address or shipping_address_id");
      }
    }
  }, {
    key: "payment",
    value: function payment(paymentDetails) {
      var _this6 = this;

      var order_id = paymentDetails.order_id,
          amount = paymentDetails.amount,
          provider = paymentDetails.provider,
          stripe_token = paymentDetails.stripe_token,
          paypal_payment_id = paymentDetails.paypal_payment_id,
          paypal_user_id = paymentDetails.paypal_user_id;

      if (order_id && amount && provider && (stripe_token || paypal_payment_id && paypal_user_id)) {
        var cart = this.getCart();
        return this.authHeaders().then(function (headers) {
          return _this6.api.request("/orders/" + order_id + "/payments", {
            method: "POST",
            headers: headers,
            body: JSON.stringify({
              amount: amount,
              order_id: order_id,
              provider: provider,
              stripe_token: stripe_token,
              paypal_payment_id: paypal_payment_id,
              paypal_user_id: paypal_user_id,
              currency: _this6.currency
            })
          });
        });
      } else {
        return Promise.reject("Invalid paymentDetails - must have an order_id, an amount, a provider, and a stripe_token or a paypal_payment_id and paypal_user_id");
      }
    }
  }, {
    key: "resendConfirmation",
    value: function resendConfirmation(orderID, email) {
      var _this7 = this;

      var path = "/orders/" + orderID + "/receipt";
      return this.authHeaders().then(function (headers) {
        return _this7.api.request(path, {
          headers: headers,
          method: "POST",
          body: JSON.stringify({ email: email })
        });
      });
    }
  }, {
    key: "claimOrders",
    value: function claimOrders() {
      var _this8 = this;

      if (this.user) {
        return this.authHeaders().then(function (headers) {
          return _this8.api.request("/claim", {
            headers: headers,
            method: "POST"
          });
        });
      }
      return Promise.resolve(null);
    }
  }, {
    key: "updateOrder",
    value: function updateOrder(orderId, attributes) {
      var _this9 = this;

      return this.authHeaders(true).then(function (headers) {
        return _this9.api.request("/orders/" + orderId, {
          headers: headers,
          method: "PUT",
          body: JSON.stringify(attributes)
        });
      });
    }
  }, {
    key: "orderHistory",
    value: function orderHistory(params) {
      var _this10 = this;

      var path = "/orders";
      if (params && params.user_id) {
        path = "/users/" + params.user_id + "/orders";
        delete params.user_id;
      }
      path = pathWithQuery(path, params);
      return this.authHeaders(true).then(function (headers) {
        return _this10.api.request(path, {
          headers: headers
        });
      }).then(function (_ref) {
        var items = _ref.items,
            pagination = _ref.pagination;
        return { orders: items, pagination: pagination };
      });
    }
  }, {
    key: "orderDetails",
    value: function orderDetails(orderID) {
      var _this11 = this;

      return this.authHeaders(true).then(function (headers) {
        return _this11.api.request("/orders/" + orderID, {
          headers: headers
        });
      });
    }
  }, {
    key: "orderReceipt",
    value: function orderReceipt(orderID, template) {
      var _this12 = this;

      var path = "/orders/" + orderID + "/receipt";
      if (template) {
        path += "?template=" + template;
      }
      return this.authHeaders(true).then(function (headers) {
        return _this12.api.request(path, {
          headers: headers
        });
      });
    }
  }, {
    key: "userDetails",
    value: function userDetails(userId) {
      var _this13 = this;

      userId = userId || this.user && this.user.id;

      return this.authHeaders(true).then(function (headers) {
        return _this13.api.request("/users/" + userId, {
          headers: headers
        });
      });
    }
  }, {
    key: "downloads",
    value: function downloads(params) {
      var _this14 = this;

      var path = "/downloads";
      if (params && params.order_id) {
        path = "/orders/" + params.order_id + "/downloads";
        delete params.order_id;
      }
      path = pathWithQuery(path, params);
      return this.authHeaders().then(function (headers) {
        return _this14.api.request(path, {
          headers: headers
        });
      }).then(function (_ref2) {
        var items = _ref2.items,
            pagination = _ref2.pagination;
        return { downloads: items, pagination: pagination };
      });
    }
  }, {
    key: "downloadURL",
    value: function downloadURL(downloadId) {
      var _this15 = this;

      var path = "/downloads/" + downloadId;
      return this.authHeaders().then(function (headers) {
        return _this15.api.request(path, {
          headers: headers
        });
      }).then(function (response) {
        return response.url;
      });
    }
  }, {
    key: "users",
    value: function users(params) {
      var _this16 = this;

      var path = pathWithQuery("/users", params);
      return this.authHeaders(true).then(function (headers) {
        return _this16.api.request(path, {
          headers: headers
        });
      }).then(function (_ref3) {
        var items = _ref3.items,
            pagination = _ref3.pagination;
        return { users: items, pagination: pagination };
      });
    }
  }, {
    key: "report",
    value: function report(name, params) {
      var _this17 = this;

      var path = pathWithQuery("/reports/" + name, params);
      return this.authHeaders(true).then(function (headers) {
        return _this17.api.request(path, {
          headers: headers
        });
      });
    }
  }, {
    key: "authHeaders",
    value: function authHeaders(required) {
      if (this.user) {
        return this.user.jwt().then(function (token) {
          return { Authorization: "Bearer " + token };
        });
      }
      return required ? Promise.reject("The API action requires authentication") : Promise.resolve({});
    }
  }, {
    key: "loadCart",
    value: function loadCart() {
      var json = localStorage.getItem(this.cartKey);
      if (json) {
        var cart = JSON.parse(json);
        this.settings = cart.settings;
        this.line_items = cart.line_items || {};
      } else {
        this.settings = null;
        this.line_items = {};
      }
    }
  }, {
    key: "loadSettings",
    value: function loadSettings() {
      var _this18 = this;

      if (this.settingsAreFresh()) {
        return Promise.resolve();
      }
      if (this._settingsPromise) {
        return this._settingsPromise;
      }

      this._settingsPromise = fetch(this.settings_path).then(function (response) {
        if (!response.ok) {
          return;
        }

        return response.json().then(function (json) {
          _this18.settings = _extends(json, { ts: new Date().getTime() });
          _this18._settingsPromise = null;
        });
      });
      return this._settingsPromise;
    }
  }, {
    key: "settingsAreFresh",
    value: function settingsAreFresh() {
      if (this.settings_path == null) {
        return true;
      }

      if (this.settings) {
        var diff = new Date().getTime() - this.settings.ts;
        return diff < this.settings_refresh_period;
      }

      return false;
    }
  }, {
    key: "verifyVatnumber",
    value: function verifyVatnumber(vatnumber) {
      var _this19 = this;

      this.vatnumber_valid = false;
      if (!vatnumber) {
        this.vatnumber_valid = false;
        return Promise.resolve(false);
      }
      if (vatnumbers[vatnumber]) {
        this.vatnumber_valid = vatnumbers[vatnumber].valid;
        return Promise.resolve(false);
      }

      return this.api.request("/vatnumbers/" + vatnumber).then(function (response) {
        vatnumbers[vatnumber] = response;
        _this19.vatnumber_valid = response.valid;
        return response.valid;
      });
    }
  }, {
    key: "verifyCoupon",
    value: function verifyCoupon(code) {
      var _this20 = this;

      return this.authHeaders(false).then(function (headers) {
        return _this20.api.request("/coupons/" + code, {
          headers: headers
        });
      });
    }
  }, {
    key: "persistCart",
    value: function persistCart() {
      var json = JSON.stringify({ line_items: this.line_items, settings: this.settings });
      localStorage.setItem(this.cartKey, json);
    }
  }]);

  return GoCommerce;
}();

exports.default = GoCommerce;


if (typeof window !== "undefined") {
  window.GoCommerce = GoCommerce;
}


//////////////////
// WEBPACK FOOTER
// ./~/gocommerce-js/lib/index.js
// module id = 724
// module chunks = 231608221292675